export enum EmailAddressType {
	to,
	cc,
	cci,
}
